'use strict';

import { isMobile } from '../utilities/breakpoints';
import { trapFocus } from '../utilities/focusTrap';

let currentIsMobile = null;
let releaseFocus = null;

const menu = {
    selectors: {
        menus: '.js-expandable-menu',
        toggles: '.js-expandable-toggle',
        closeBtn: '.js-close',
        burger: '.js-button-burger',
        navMobile: '.js-nav-mobile',
        overlay: '#menu-overlay'
    }
};

/* ---------- HELPERS ---------- */

function hideOverlay() {
    const $ov = $(menu.selectors.overlay);
    if ($ov.length) $ov.removeClass('is-visible').attr('aria-hidden', 'true');
}

function showOverlay() {
    const $ov = $(menu.selectors.overlay);
    if ($ov.length) $ov.addClass('is-visible').attr('aria-hidden', 'false');
}

function closeDesktop() {
    const $menus = $(menu.selectors.menus);
    const $toggles = $(menu.selectors.toggles);

    $menus.stop(true, true).removeClass('is-open').attr('aria-hidden', 'true').slideUp(300);
    $toggles.attr('aria-expanded', 'false').removeClass('active');
    $('html, body').removeClass('menu-expanded');

    if (releaseFocus) { releaseFocus(); releaseFocus = null; }
    hideOverlay();
}

function closeMobile() {
    const $menus = $(menu.selectors.menus);
    const $toggles = $(menu.selectors.toggles);
    const $nav = $(menu.selectors.navMobile);

    $menus.removeClass('is-open').attr('aria-hidden', 'true');
    $toggles.attr('aria-expanded', 'false');
    $nav.removeClass('is-open');

    $('html, body').removeClass('menu-open');
    hideOverlay();
}

function closeAll() {
    if (isMobile()) closeMobile();
    else closeDesktop();
}

/* ---------- DESKTOP ---------- */

function initDesktop() {
    const $toggles = $(menu.selectors.toggles);

    $toggles.off('click.desktop').on('click.desktop', function (e) {
        e.preventDefault();
        const $btn = $(this);
        const $menu = $btn.siblings(menu.selectors.menus);
        const wasOpen = $menu.hasClass('is-open');

        closeDesktop();

        if (!wasOpen) {
            $menu.stop(true, true).addClass('is-open').attr('aria-hidden', 'false').slideDown(300);
            $btn.attr('aria-expanded', 'true').addClass('active');
            $('html, body').addClass('menu-expanded');
            showOverlay();

            releaseFocus = trapFocus($menu[0]);
        } else if (!$btn.is(e.target) && $btn.data('href')) {
            window.location.href = $btn.data('href');
        }
    });

    // Outside click
    $(document).off('click.desktopMenu').on('click.desktopMenu', function (e) {
        if ($(e.target).closest(`${menu.selectors.menus}, ${menu.selectors.toggles}`).length) return;
        closeDesktop();
    });

    // ESC close
    $(document).off('keydown.desktopMenu').on('keydown.desktopMenu', function (e) {
        if (e.key === 'Escape') {
            const $activeButton = $(`${menu.selectors.toggles}.active`);
            closeDesktop();
            if ($activeButton.length) $activeButton.focus();
        }
    });
}

/* ---------- MOBILE ---------- */

function initMobile() {
    const $burger = $(menu.selectors.burger);
    const $nav = $(menu.selectors.navMobile);

    // Burger
    $burger.off('click.mobileBurger').on('click.mobileBurger', function (e) {
        e.preventDefault();
        const willOpen = !$nav.hasClass('is-open');

        if (willOpen) {
            $nav.addClass('is-open');
            $('html, body').addClass('menu-open');
            showOverlay();
        } else {
            closeMobile();
        }
    });

    // Accordion toggles
    $(document).off('click.mobileToggle').on('click.mobileToggle', menu.selectors.toggles, function (e) {
        e.preventDefault();
        const $btn = $(this);
        const $menu = $btn.nextAll(menu.selectors.menus).first();
        const wasOpen = $menu.hasClass('is-open');

        $(menu.selectors.menus).removeClass('is-open').attr('aria-hidden', 'true');
        $(menu.selectors.toggles).attr('aria-expanded', 'false');

        if (!wasOpen) {
            $menu.addClass('is-open').attr('aria-hidden', 'false');
            $btn.attr('aria-expanded', 'true');
        }
    });

    // Close button inside panel
    $(document).off('click.mobileClose').on('click.mobileClose', menu.selectors.closeBtn, function (e) {
        e.preventDefault();
        const $menu = $(this).closest(menu.selectors.menus);
        $menu.removeClass('is-open').attr('aria-hidden', 'true');
        $menu.prevAll(menu.selectors.toggles).first().attr('aria-expanded', 'false');
    });

    // Outside click
    $(document).off('click.mobileOutside').on('click.mobileOutside', function (e) {
        if ($(e.target).closest(`${menu.selectors.menus}, ${menu.selectors.toggles}, ${menu.selectors.burger}`).length) return;
        closeMobile();
    });
}

/* ---------- GTM ---------- */
function bindMenuTrackingOnce() {
    if (bindMenuTrackingOnce.bound) return;
    bindMenuTrackingOnce.bound = true;

    $(document).on('click.menuTracking', `${menu.selectors.toggles}, ${menu.selectors.menus} a`, function () {
        if (!isMobile()) {
            const label = $(this).text().trim();
            if (label !== 'ACADEMY') {
                try { localStorage.setItem('menu_click', 'true'); } catch (e) {
                    console.warn('Unable to save in local storage :', e);
                }
            } else {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ menu: { lv2: '', lv1: label }, event: 'menu_click' });
            }
        }
    });
}

/* ---------- INIT ---------- */
function initByMode(mobile) {
    // Clean handlers from previous mode
    $(document).off('.desktopMenu .mobileMenu .mobileToggle .mobileClose .mobileOutside');
    $(menu.selectors.toggles).off('click.desktop');
    $(menu.selectors.burger).off('click.mobileBurger');

    closeAll();

    if (mobile) {
        initMobile();
    } else {
        initDesktop();
    }
}

export default function initMenu() {
    bindMenuTrackingOnce();

    currentIsMobile = isMobile();
    initByMode(currentIsMobile);

    // Re-init on resize
    window.addEventListener('resize', () => {
        const nextIsMobile = isMobile();

        closeAll();

        if (nextIsMobile !== currentIsMobile) {
            currentIsMobile = nextIsMobile;
            initByMode(currentIsMobile);
        }
    });
}
